import { render, staticRenderFns } from "./RequestApproverDialog.vue?vue&type=template&id=0f8fc833&scoped=true&"
import script from "./RequestApproverDialog.vue?vue&type=script&lang=js&"
export * from "./RequestApproverDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestApproverDialog.vue?vue&type=style&index=0&id=0f8fc833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fc833",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/RequestTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-request%2FRequestApproverDialog.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports